<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg *:first:rounded-l-md *:last:rounded-r-md">
            <router-link :to="`/stripe-outbox-events?search=${row.id}`" class="btn-list-action">
              <ArrowTopRightOnSquareIcon class="mr-2 h-3 text-slate-400" />
              Outbox Event
            </router-link>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { ref, watch } from 'vue';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { EllipsisHorizontalIcon, ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline';
import { OnClickOutside } from '@vueuse/components';

const props = defineProps({
  row: {
    type: Object,
    default: () => ({})
  },
  isRowHovered: {
    type: Boolean,
    default: false
  }
});

const isOpened = ref(false);

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
